<template>
	<div class='filter-table-lpo-component'>
		<b-dropdown ref='filterDropdown' class='lpo-filter-dropdown' :text='text' @show='onShow' variant='dark' :class='{ active: this.columnIsFiltered(this.column) }'>
			<div class='filter-lpo-dropdown-content'> 
				<div class='lpo-filter-dropdown-header'>
					<custom-p-input v-model='searchInput' placeholder='Поиск...'/>
					<button @click='clearCheckedItems' class='clear-filter-list-btn'>Снять выделения</button>
				</div>

				<div>
					<ul class='filter-table-lpo-filter-list'>
						<li v-for='item in filterList' v-if='matchToSearch(item)' class='li-item'>
							<custom-p-checkbox
								v-model='checkedItems'
								multiple
								:multipleValue='item.filter_value'
								:label='item.filter_value ? item.filter_value : "(пусто)"'
							/>
						</li>
					</ul>
					<button class='custom-sm-btn ok-btn' @click.prevent='applyFilter'>Применить</button>
				</div>
			</div>
		</b-dropdown>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
	const GET_FILTER_LIST = process.env.VUE_APP_ROOT_API + 'get_journal_lpo_filter_list.php';
	
	export default {
		name: 'JournalLpo__filter',
		props: {
			column: String,
			activeFilter: Object,
			text: {
				type: String,
				default: ''
			}
		},
		data: () => ({
			searchInput: null,
			checkedItems: [],
		}),
		computed: {
			...mapState('journalLpo', {
				filterObj: state => state.filter.filterObj,
				filterList: state => state.filter.filterList
			}),
			...mapGetters('journalLpo', [
				'journalIsFiltered',
				'columnIsFiltered',
				'filterStr'
			])
		},
		methods: {
			clearCheckedItems() {
				this.checkedItems = [];
			},
			onShow() {
				this.clearFilterList();
				this.getFilterList(this.column);
				this.restoreCheckedItems();
				this.searchInput = '';
			},
			matchToSearch(item) {
				if (item.filter_value === null && (this.searchInput === null || this.searchInput === '') ) return true;
				else if (item.filter_value === null) return false;
				if (this.searchInput === null || this.searchInput === '') return true;
				if ( item.filter_value.toLowerCase().includes(this.searchInput.toLowerCase()) )
					return true;
				return false;
			},
			applyFilter() {
				this.$refs.filterDropdown.hide(true);
				const payload = {
					column: this.column,
					checkedItems: this.checkedItems
				};
				this.setFilterObjColumnItems(payload).then(res => {
					this.getJournalLpo(this.filterStr);
				});
			},
			restoreCheckedItems() {
				this.checkedItems = [];
				if (!this.filterObj[this.column].length) {
					return;
				}
				this.checkedItems = this.filterObj[this.column].slice();
			},
			...mapMutations('journalLpo', [
				'clearFilterList'
			]),
			...mapActions('journalLpo', [
				'getFilterList',
				'setFilterObjColumnItems'
			]),
			...mapActions('journalLpo', [
				'getJournalLpo',
			])
		},
		created() {
			this.restoreCheckedItems();
		}
	}
</script>

<style>
	.filter-table-lpo-component .dropdown.btn-group {
		width: 100%;
	}
	.filter-table-lpo-component .dropdown.b-dropdown .b-dropdown-form {
		padding: 0;
	}
	.filter-table-lpo-component .b-dropdown .dropdown-menu {
		box-shadow: 0px 0px 3px gray;
	}
	
	.filter-table-lpo-component .dropdown > .dropdown-toggle {
		font-size: 12px;
		padding: 6px 2px;
		width: 100%;
	}
	.filter-table-lpo-component .dropdown.active > .dropdown-toggle {
		background-color: dodgerblue;
	}
	.filter-table-lpo-component .li-item {
		margin-bottom: 8px;
	}
	.filter-table-lpo-component .filter-lpo-dropdown-content {
		padding: 10px;
		padding-bottom: 4px;
	}
	.filter-table-lpo-component .lpo-filter-dropdown-header {
		/*margin: auto;
		width: 95%;*/
	}
	.filter-table-lpo-component .lpo-filter-dropdown-header > input {
		font-size: 14px;
		padding-left: 8px;
		width: 100%;
	}
	.filter-table-lpo-component .lpo-filter-dropdown-header > .clear-filter-list-btn {
		background-color: #343a40;
		border: none;
		color: white;
		font-size: 14px;
		outline: none;
		margin-top: 16px;
		width: 100%;
	}
	.filter-table-lpo-component .filter-table-lpo-filter-list {
		margin-top: 10px;
		list-style-type: none;
		padding: 6px;
		max-height: 400px;
		overflow-y: auto;
		width: 200px;
		font-size: 14px;
		border: 1px solid #999;
		width: 100%;
		min-width: 200px;
	}

	.filter-table-lpo-component .filter-table-lpo-filter-list .filter-list-item {
		cursor: pointer;
		margin-left: 4px;
		font-weight: normal;
		font-size: 0.9rem;
	}
	.filter-table-lpo-component .filter-table-lpo-filter-list .empty-filter-list-item {
		color: #aaa;
	}
	.filter-table-lpo-component .filter-lpo-dropdown-content .ok-btn {
		float: right;
		margin-top: 10px;
	}
</style>